import React, { useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton/TextButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import WidgetBoxWrapper from './_partials/WidgetBoxWrapper/WidgetBoxWrapper';
import useGruser from '../../hooks/useGruser';
import WidgetHeaderMobile from './lego/WidgetHeaderMobile/WidgetHeaderMobile';
import WidgetHeader from './lego/WidgetHeader/WidgetHeader';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import useModuleData from '../../hooks/useModuleData';
import WidgetEditControls from './_partials/WidgetEditControls/WidgetEditControls';
import s from './WidgetBox.scss';
const WidgetBox = ({ moduleId, header, className, headerClassName, dataHook, children, headerExtras, count, seeAllUrl, configPopoverComponent, confirmRemove })=>{
    const gruser = useGruser();
    const isMobile = useContext(MobileContext);
    const { moduleData } = useModuleData(moduleId);
    const { t } = useTranslation();
    if (!gruser) {
        return null;
    }
    const renderHeaderContents = ()=>{
        if (!seeAllUrl) {
            return header;
        }
        return /*#__PURE__*/ React.createElement(BiLink, {
            biData: BiData({
                evid: 106,
                creatorid: BiContextProvidedValue,
                typeid: gruser.gruserTypeid,
                itemid: gruser.gruserItemid,
                sectionname: BiContextProvidedValue
            }),
            href: seeAllUrl
        }, header);
    };
    const renderRightSideSeeAllLink = ()=>{
        if (!moduleData['hasMore']) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(TextButton, {
            size: "medium",
            variant: "main",
            biData: BiData({
                evid: 106,
                typeid: gruser.gruserTypeid,
                itemid: gruser.gruserItemid,
                creatorid: BiContextProvidedValue,
                sectionname: BiContextProvidedValue
            }),
            href: seeAllUrl,
            className: s['see-all'],
            "data-role": "see-all-link"
        }, t('gruser.widgetbox.button.seeAll'));
    };
    const renderHeaderExtraElements = ()=>{
        return /*#__PURE__*/ React.createElement("div", {
            className: s['header-extras']
        }, headerExtras, /*#__PURE__*/ React.createElement(WidgetEditControls, {
            moduleId: moduleId,
            configPopoverComponent: configPopoverComponent,
            confirmRemove: confirmRemove
        }), renderRightSideSeeAllLink());
    };
    return /*#__PURE__*/ React.createElement(WidgetBoxWrapper, {
        "data-role": "widget",
        className: c(s['root'], className),
        "data-hook": dataHook,
        "data-moduleid": moduleId,
        "data-userid": gruser.gruserId
    }, isMobile ? /*#__PURE__*/ React.createElement(WidgetHeaderMobile, {
        rootClassName: headerClassName,
        header: renderHeaderContents(),
        count: count,
        isSticky: false,
        extras: renderHeaderExtraElements()
    }) : /*#__PURE__*/ React.createElement(WidgetHeader, {
        className: headerClassName,
        header: renderHeaderContents(),
        count: count,
        extras: renderHeaderExtraElements()
    }), children);
};
WidgetBox.displayName = 'WidgetBox';
export default WidgetBox;
